import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Factura } from 'src/app/Models/factura/factura';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { Personal } from 'src/app/Models/personal/personal';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { SearchFacturaComponent } from '../compras/search-factura/search-factura.component';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';

@Component({
  selector: 'app-saldos',
  templateUrl: './saldos.component.html',
  styleUrls: ['./saldos.component.css']
})
export class SaldosComponent implements OnInit {


  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(SearchFacturaComponent, null) modalfactura: SearchFacturaComponent;
  public usuario: any;
  public ingreso: Ingreso = new Ingreso();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public index: number = 0;
  public numitem: number = 0;
  public tiposgastos: any[] = [];
  public pagarticulo: any;
  public listsaldos: any[] = []
  public filtro:Filtro=new Filtro()
  public factura:Factura=new Factura()
  public listapersonal: Personal[] = [];
  public personal:Personal=new Personal()
  public saldoTotal:number=0
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
    this.title.setTitle('Saldos | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.filtro.fecha = moment(new Date()).format('YYYY-MM-DD')
    this.ingreso.hora = moment(new Date()).format('HH:mm:ss')
    this.ingreso.estado = "emitido";
    this.factura.serie='0'
    this.factura.numero=0

    console.log(this.usuario);
    console.log(this.usuario.idpersonal.idpersonal);

    this.getPersonal();
    if (!(this.usuario.idpersonal.idnivel != 2)) {
      this.getliquidacion(this.usuario.idpersonal.idpersonal );  
    }
    
    
  }

  getPersonal(){
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  getTiposGastos() {
    this.data.GetSimple(this.data.api.tiposgastos).subscribe(r => {
      this.tiposgastos = r
      console.log(r)
    })
  }

  getListaSaldos() {
    this.filtro.idvende=this.usuario.idpersonal.idpersonal
    console.log('Este es el filtro',this.filtro);
    
    // this.filtro.idliquida=''
    this.data.Post('getsaldoliquidacion',this.filtro).subscribe(r => {
      console.log(r);
      this.listsaldos = r
    },(error)=>{console.log(error.error)})
  }

  CalcularSaldo(entrada:number,salida:number):number{
    if (entrada>salida) {
      return entrada-salida
    }else
    return 0
  }

  getliquidacion(idpersonal:any) {
    
      const datapersonal = { 'fecha': this.filtro.fecha, 'idpersonal': idpersonal}
      console.log(datapersonal);

      this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
        // Manejar la respuesta exitosa
        this.filtro.idliquida = data.idliquida
        console.log('Liquidación obtenida:', data);
        console.log(this.filtro.idliquida );
        
        this.getListaSaldos()
      },
        (error) => {
          // Manejar el error de obtener la liquidación
          console.error('Error al obtener la liquidación:', error);
          // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
          this.usuario.idpersonal.idnivel != 2?this.data.notify("Se necesita crear una liquidacion.", "Liquidacion no encontrada.", this.data.alertType.info):this.auth.logoutUser()
        }
      );
    
  }

  updateFactura(factura:Factura){
    factura.estado='CAN';
    this.data.Put(this.data.api.factura,factura.idfactura.toString(),factura).subscribe(r=>console.log(r.message, r))
  }

  Guardaringreso() {
    console.log(this.ingreso);

    this.data.Post(this.data.api.ingreso, this.ingreso).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log('Ingreso guardado:', data);
      this.updateFactura(this.factura)
      this.data.notify("Operacion exitosa", "Exito", this.data.alertType.success)
      this.factura=new Factura()
      this.ingreso.concepto = ""
      this.ingreso.total = 0;

    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        this.data.notify("Operacion fallida", "Error", this.data.alertType.error)
      }
    );

  }

  showmodalfactu(){
    this.filtro.tarjeta='13'
    this.filtro.estado='EMI'
    this.modalfactura.filtro=this.filtro
    this.modalfactura.facturas=[]
    this.modalfactura.show(()=>{
      if (this.modalfactura.factura) {
        this.factura=this.modalfactura.factura
        this.ingreso.total=this.factura.total
        this.ingreso.idfactura=this.factura.idfactura.toString()
      }
    })
  }
}
